import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page } from '../ui'
import { UnifiedSearchView } from '../components/views/unifiedSearch'

/** Client Search: the view owns its PageHeader so it can surface result counts and actions. */
function ClientSearch() {
    return (
        <div className="clients">
            <Sidebar />
            <MainView>
                <Page>
                    <UnifiedSearchView isSupportSearch={true} />
                </Page>
            </MainView>
        </div>
    )
}

export default ClientSearch
